import { useEffect, useRef } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface PaymentStatusHookProps {
  orderId: string | null;
  onStatusChange: (status: string) => void;
}

export const usePaymentStatus = ({ orderId, onStatusChange }: PaymentStatusHookProps) => {
  const timeoutRef = useRef<any>(null);
  const channelRef = useRef<any>(null);
  const hasReceivedUpdate = useRef(false);

  useEffect(() => {
    if (!orderId) return;

    console.log(`🔍 Escutando broadcasts para pedido: ${orderId}`);
    hasReceivedUpdate.current = false;

    // Configurar canal para escutar broadcasts
    const channel = supabase.channel(`payment-${orderId}`);
    channelRef.current = channel;

    // Escutar eventos de confirmação de pagamento
    channel.on('broadcast', { event: 'payment_confirmed' }, (payload) => {
      console.log('📡 Broadcast recebido:', payload);
      
      if (payload.payload?.orderId === orderId && !hasReceivedUpdate.current) {
        hasReceivedUpdate.current = true;
        onStatusChange(payload.payload.status);
        console.log('✅ Status atualizado via broadcast:', payload.payload.status);
      }
    });

    // Subscribir ao canal
    channel.subscribe((status) => {
      console.log('📡 Status da subscição:', status);
    });

    // Timeout de segurança de 90 segundos
    timeoutRef.current = setTimeout(() => {
      if (!hasReceivedUpdate.current) {
        console.log('⏰ Timeout 90s - marcando como validação');
        hasReceivedUpdate.current = true;
        onStatusChange('pagamento_em_validacao');
      }
    }, 90000);

    return () => {
      console.log(`🧹 Cleanup pedido: ${orderId}`);
      
      if (channelRef.current) {
        supabase.removeChannel(channelRef.current);
        channelRef.current = null;
      }
      
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [orderId, onStatusChange]);
};